// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1BVqK","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__1-3zj","gfeWrapper":"CalendarEvent_gfeWrapper__3WOIP"};